export default __webpack_public_path__ + "static/top-man-a9f82bc2ccd0cf921eaf6cf68c98a09c.png";